import{registerElementSafely as r}from"@cds/core/internal";import{CdsDatalist as s}from"./datalist.element.js";import"@cds/core/forms/register.js";import"@cds/core/icon/register.js";r("cds-datalist",s);
